import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiZap, FiMail, FiStar } = FiIcons;

const RenewalCTA = () => {
  return (
    <motion.div
      className="bg-gradient-to-br from-proactuary-blue-600/40 to-proactuary-green-600/40 rounded-2xl p-8 border border-proactuary-blue-500/50 text-center relative overflow-hidden"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      {/* Background Animation */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-20 h-20 bg-white rounded-full animate-ping" />
        <div className="absolute bottom-10 right-10 w-16 h-16 bg-proactuary-green-400 rounded-full animate-pulse" />
        <div className="absolute top-1/2 left-1/4 w-12 h-12 bg-proactuary-blue-400 rounded-full animate-bounce" />
      </div>

      <motion.div
        className="relative z-10"
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-white mb-6 flex items-center justify-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <SafeIcon icon={FiZap} className="text-yellow-400 mr-4 animate-pulse-glow" />
          Secure Your 2026 Partnership - Early Renewal Benefits Available
          <SafeIcon icon={FiZap} className="text-yellow-400 ml-4 animate-pulse-glow" />
        </motion.h2>

        <motion.p
          className="text-xl text-white/90 mb-8 max-w-4xl mx-auto leading-relaxed"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          The actuarial AI education market continues expanding. Your 2025 sponsorship established strong brand recognition - now secure your 2026 position with enhanced benefits and early renewal pricing.
        </motion.p>

        <motion.div
          className="space-y-4 mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          <div className="glass-effect rounded-xl p-6 text-left max-w-2xl mx-auto border border-proactuary-blue-400/30">
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center">
              <SafeIcon icon={FiStar} className="text-yellow-400 mr-3" />
              2026 Enhanced Benefits with ProActuary
            </h3>
            <ul className="space-y-2 text-white/90">
              <li className="flex items-center">
                <div className="w-2 h-2 bg-proactuary-green-400 rounded-full mr-3" />
                Expanded global reach with new market penetration
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-proactuary-blue-400 rounded-full mr-3" />
                Enhanced digital marketing integration across ProActuary channels
              </li>
              <li className="flex items-center">
                <div className="w-2 h-2 bg-proactuary-green-400 rounded-full mr-3" />
                Premium sponsor placement in ProActuary's growing ecosystem
              </li>
            </ul>
          </div>
        </motion.div>

        <motion.a
          href="mailto:virtualsummit@proactuary.com"
          className="inline-flex items-center space-x-3 bg-gradient-to-r from-proactuary-blue-500 to-proactuary-green-500 hover:from-proactuary-blue-600 hover:to-proactuary-green-600 text-white font-bold py-4 px-8 rounded-full text-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-2xl"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1.0 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <SafeIcon icon={FiMail} className="text-2xl" />
          <span>Secure Your 2026 ProActuary Partnership</span>
          <SafeIcon icon={FiZap} className="text-2xl animate-pulse" />
        </motion.a>

        <motion.p
          className="text-white/70 mt-4 text-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          Reserve your 2026 partnership today | Contact: virtualsummit@proactuary.com
        </motion.p>

        {/* ProActuary Brand Footer - Simplified text only */}
        <motion.div
          className="mt-6 pt-6 border-t border-white/20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.4 }}
        >
          <div className="text-white/60 text-sm">
            Your Partner in Actuarial Excellence
          </div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default RenewalCTA;